










import { Component, Mixins } from "vue-property-decorator";
import { HashCalculator } from "../../../domain/system";
import { ModelEditableMixin } from "../../system/mixins";

@Component({
  components: {
  }
})
export default class DeveloperAuthenticator extends Mixins(ModelEditableMixin) {
  editingSource: boolean;

  data(): any {
    return {
      password: null as string,
    };
  }
  password: string;

  authenticate(): void {
    // TODO: 要認証実装.
    const hash = HashCalculator.Calculate(this.password);
    this.password = "";
    if (hash === 1264798178 || hash === -1679507699) {
      this.editingSource = true;
    }
  }
}
